import React from 'react';
import s from './Loader.scss';
export const Loader = () => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "-9 -9 18 18",
  className: s.loader,
  fill: "none",
  strokeWidth: "3",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  className: s.stroke1,
  stroke: "currentColor",
  d: "M -4.4083893921935475 6.067627457812106 A 7.5 7.5 0 1 0 4.592425496802575e-16 -7.5"
}), /*#__PURE__*/React.createElement("path", {
  className: s.stroke2,
  stroke: "currentColor",
  d: "M 4.408389392193548 6.067627457812106 A 7.5 7.5 0 0 0 4.592425496802575e-16 -7.5"
}));
//# sourceMappingURL=Loader.js.map